import { clsx } from "clsx";
import React, { useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import { RenderWhen } from "../../../../../../components";
import { Title } from "../../../../../../components/dynamicanalysis";
import { ProcessTreeItem } from "../../../../@types";
import ProcessTree from "./ProcessTree";

const DEFAULT_NUMBER_OF_VISIBLE_ITEMS = 8;

interface Props {
  data: Array<ProcessTreeItem>;
  showAdditionalInfo?: boolean;
}

const flatten = ({
  process_id,
  children = []
}: ProcessTreeItem): Array<number> => [
  process_id,
  ...children.flatMap(flatten)
];

const ProcessTreeContainer: React.FC<Props> = ({
  data,
  showAdditionalInfo = true
}) => {
  const size = useMemo(
    () =>
      data?.flatMap(({ process_id, children = [] }: ProcessTreeItem) => [
        process_id,
        ...children.flatMap(flatten)
      ]).length,
    [data]
  );
  const limitProcessTreeHeight = size > DEFAULT_NUMBER_OF_VISIBLE_ITEMS;

  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const className = clsx(
    "process-tree",
    limitProcessTreeHeight && !isExpanded && "process-tree--limited-height"
  );

  return (
    <section className="process-tree__container">
      <Title headingLevel="h3" title="Process Tree">
        <RenderWhen condition={limitProcessTreeHeight}>
          <Button
            data-testid="process-tree-expand"
            style={{ marginLeft: "auto", minWidth: "initial" }}
            variant="primary"
            size="sm"
            onClick={() => setIsExpanded(prev => !prev)}
          >
            {isExpanded ? "Collapse" : "Expand"}
          </Button>
        </RenderWhen>
      </Title>
      <ProcessTree
        className={className}
        data={data}
        showAdditionalInfo={showAdditionalInfo}
      />
    </section>
  );
};

export default ProcessTreeContainer;
